@if (isImageFile) {
	<img #img [alt]="file.name" [class]="class" />
} @else {
	<div class="d-flex align-items-center justify-content-center">
		<i aria-hidden="true" class="far fa-file-alt fa-3x"></i>
	</div>
}
